import { render, staticRenderFns } from "./Pengumuman.vue?vue&type=template&id=3c331110"
import script from "./Pengumuman.vue?vue&type=script&lang=js"
export * from "./Pengumuman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports